import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import PrimaryButton from '../../../../lib/ui/buttons/PrimaryButton';
import {
  Container, Content, Header, Info,
} from './css';
import AccessorialsPicker from '../../../../lib/ui/accessorialsPicker';

const Step3 = ({
  formData = {}, step, accessorialsList, nextStep, valid, dispatch, formName, fieldsShouldBeBlocked,
}) => {
  const { measurementList } = formData;

  const isUSShipment = formData.USShipment;
  const shipperIsResidential = formData.shipperResidentialAddress;
  const consigneeIsResidential = formData.consigneeResidentialAddress;
  const hasDangerousGoods = measurementList && measurementList.some(({ itemDangerous }) => itemDangerous);

  if (step === 2) {
    return (
      <Container>
        <Header>
          <Info>{t('AdditionalChargesInfo')}</Info>
          <PrimaryButton label={t('Next')} disabled={!valid} onClick={nextStep} />
        </Header>
        <Content>
          <AccessorialsPicker
            source={accessorialsList}
            formName={formName}
            formData={formData}
            isUSShipment={isUSShipment}
            shipperIsResidential={shipperIsResidential}
            consigneeIsResidential={consigneeIsResidential}
            hasDangerousGoods={hasDangerousGoods}
            dispatch={dispatch}
            fieldsShouldBeBlocked={fieldsShouldBeBlocked}
          />
        </Content>
      </Container>
    );
  }

  return null;
};

Step3.propTypes = {
  formData: PropTypes.shape({
    measurementList: PropTypes.arrayOf(
      PropTypes.shape({
        itemDangerous: PropTypes.bool,
      }),
    ),
    USShipment: PropTypes.bool,
    shipperResidentialAddress: PropTypes.bool,
    consigneeResidentialAddress: PropTypes.bool,
  }),
  step: PropTypes.number,
  accessorialsList: PropTypes.array,
  nextStep: PropTypes.func,
  valid: PropTypes.bool,
  dispatch: PropTypes.func,
  formName: PropTypes.string,
  fieldsShouldBeBlocked: PropTypes.bool,
};

export default Step3;
